<template>
<div class="page-box login-layout">
  <div class="login-layout-title">
    欢迎登陆
  </div>
  <van-field v-model="formData.name" maxlength="18" label="姓名" placeholder="请输入您的姓名">
  </van-field>
  <van-field v-model="formData.phone" type="digit" name="手机号" disabled label="手机号" placeholder="请输入您的手机号"></van-field>
  <van-field
    class="send-code"
    label="手机验证码"
    v-model="formData.code"
    type="digit"
    center
    clearable
    placeholder="请输入验证码"
  >
    <!-- <div slot="left-icon"></div> -->
    <template #button>
      <van-button size="small" type="primary" @click.stop="sendCode">{{sms.message}}</van-button>
    </template>
  </van-field>

  <van-button style="margin: 60px 40px 0; background: #29C37F; font-size: 15px; font-weight: 500;" type="primary" round @click="Register">快速登录</van-button>
</div>

</template>

<script>
import { mapActions } from 'vuex'
import { apiQihooLogin } from "@/api/index"
import { userDetail, security, verificationCode } from '@/views/index/api/';
import baizeCoder from '@/common/js/baize_coder'
export default {
  name: "login",
  data() {
    return {
      formData: {
        phone: '',
        is360Login: false,
        name: '',
        code: ''
      },
      sms: {
        intervalId: 0,
        countDown: 0,
        message: '发送验证码',
      },
    };
  },
  async mounted() {
    let phone = sessionStorage.getItem("userPhone")

    if (phone) {
      this.formData.phone = phone
    }
  },
  methods: {
    ...mapActions(['setUserInfo']),
    async sendCode () {
      var reg = /^[1][0-9]{10}$/

      if(!reg.test(this.formData.phone) || !this.formData.phone) {
        this.$toast('请填写正确号码！')
        return
      }
      if (this.sms.countDown > 0) {
        return false;
      }

      let params = {
        phone: this.formData.phone,
      }
      let encrypt = baizeCoder(params);

      let res = await verificationCode(encrypt)

      this.sms.countDown = 60;
      this.sms.message = `剩余${this.sms.countDown}秒`;
      this.sms.intervalId = setInterval(() => {
        --this.sms.countDown;
        this.sms.message =
          this.sms.countDown === 0
            ? '发送验证码'
            : `剩余${this.sms.countDown}秒`;
        if (this.sms.countDown === 0) {
          clearInterval(this.sms.intervalId);
        }
      }, 1000);
    },
    // 确定登陆
    async Register(){
        if (!this.formData.name) {
          this.$toast("请输入您的姓名");
          return false;
        }

        if(!this.formData.code){
          this.$toast("请输入验证码");
          return false;
        }

        let res = await apiQihooLogin(this.formData)
        if (res.success) {
          this.$toast.success('登录成功')
          this.getUserInfoData(res.data.key)
        }
    },
    async getUserInfoData (userKey) {
      let res = await userDetail({
        primaryKey: userKey
      })

      res.data.flag = true
      res.data.token = sessionStorage.getItem('token')
      sessionStorage.setItem('userInfo', JSON.stringify(res.data))
      this.setUserInfo(res.data)
      sessionStorage.removeItem("userPhone")
      this.$router.back(-1)
    }
  }
};
</script>

<style lang="scss">
.login-layout {
  min-height: 500px;
  padding: 50px 15px;

  .login-layout-title {
    font-size: 24px;
    font-weight: 600;
    color: #212121;
    margin: 25px 5px;
  }

  .van-field__left-icon {
    width: 16px;
    height: 16px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .send-code {
    padding-right: 0 !important;
  }
}
</style>
